import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { COLORS_ADMIN_PAGE } from '../../conf/constants';
import { cleanFilename, getFileType, getFileTypeLabel } from '../utils/fileUtils';
import { DocumentViewerProps } from '../types/contractor.types';
import OfficeDocumentViewer from './OfficeDocumentViewer';

const DocumentViewer: React.FC<DocumentViewerProps> = ({ document }) => {
  if (!document) {
    return (
      <Box sx={{ textAlign: 'center', p: 3 }}>
        <Typography>No document selected</Typography>
      </Box>
    );
  }

  const fileType = getFileType(document.mimeType, document.filename);
  
  const renderViewer = () => {
    switch (fileType) {
      case 'image':
        return (
          <img 
            src={cleanFilename(document.filename)} 
            alt={document.type} 
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} 
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
        );

      case 'pdf':
        return (
          <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body2" sx={{ mb: 1, color: '#2196f3', textAlign: 'center' }}>
              PDF Document Viewer
            </Typography>
            <iframe
              src={cleanFilename(document.filename)}
              style={{ 
                width: '100%', 
                height: '100%', 
                border: 'none',
                borderRadius: '4px'
              }}
              title="PDF Document"
            />
          </Box>
        );

      case 'word':
      case 'excel':
      case 'powerpoint':
      case 'graphics':
        return <OfficeDocumentViewer filename={document.filename} fileType={fileType} />;

      default:
        return (
          <Box sx={{ textAlign: 'center', p: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              No preview available for this file type
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, color: '#666' }}>
              File type: {document.mimeType || 'Unknown'}
            </Typography>
            <Button 
              variant="contained"
              href={cleanFilename(document.filename)}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ bgcolor: COLORS_ADMIN_PAGE.PRIMARY }}
            >
              Download File
            </Button>
          </Box>
        );
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: COLORS_ADMIN_PAGE.BACKGROUND,
        height: '55vh',
        width: '100%',
        textAlign: 'center',
        color: COLORS_ADMIN_PAGE.TEXT_SECONDARY,
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
      {renderViewer()}
    </Box>
  );
};

export default DocumentViewer;